import React, { useState, useEffect, Suspense, useRef } from "react";
import {
  ZapparCamera,
  InstantTracker,
  ZapparCanvas,
  BrowserCompatibility,
} from "@zappar/zappar-react-three-fiber";
import { useLoader, useFrame, Canvas } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import {
  useAnimations,
  useProgress,
  Html,
  OrbitControls,
  useEnvironment,
} from "@react-three/drei";
import { globalActor } from "./state/GlobalContextProvider";
import { useSelector } from "@xstate/react";

import Dom from "./dom/Dom";
import Scene from "./3d/Scene";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { LoadingManager, TextureLoader } from "three";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader.js";
import * as THREE from "three";
window.THREE = THREE;
function Loader() {
  const { active, progress, errors, item, loaded, total } = useProgress();
  return (
    <Html center>
      <div className="Screen Start Loading">
        <div></div>
        <h1>
          <span className="visually-hidden">
            Miebo (perfluorohexyloctane ophtalmic solution)
          </span>
        </h1>
        <p>LOADING</p>
        {/* <button onClick={(_) => globalActor.send({ type: "START" })}>
    START
  </button> */}
      </div>
    </Html>
  );
}

// const modelUrl = process.env.PUBLIC_URL + "/Miebo_DraftAnimation_002/1.glb";
const modelUrl =
  process.env.PUBLIC_URL + "/Miebo_DraftAnimation_0030_GLB-v1.glb";
// const envUrl = process.env.PUBLIC_URL + "/footprint_court_1k.hdr";
const envUrl = process.env.PUBLIC_URL + "/venice_sunset_1k.hdr";

const preloadDefaultOptions = {
  files: [],
  path: "",
  preset: undefined,
  extensions: undefined,
};
useEnvironment.preload = (preloadOptions) => {
  const options = { ...preloadDefaultOptions, ...preloadOptions };
  let { files, path = "" } = options;
  const { preset, extensions } = options;

  const extension = "hdr";

  if (extension === "webp" || extension === "jpg" || extension === "jpeg") {
    throw new Error("useEnvironment: Preloading gainmaps is not supported");
  }

  const loader = RGBELoader;
  // const loader = EXRLoader;
  if (!loader)
    throw new Error("useEnvironment: Unrecognized file extension: " + files);

  useLoader.preload(
    // @ts-expect-error
    loader,
    files,
    (loader) => {
      loader.setPath?.(path);
      if (extensions) extensions(loader);
      loader.manager = new LoadingManager();
      loader.manager.onLoad = (e) => {
        globalActor.send({ type: "LOADED_ENV" });
      };
    }
  );
};
useEnvironment.preload({ files: envUrl });
const placeUrl = process.env.PUBLIC_URL + "/PlaceIcon.png";
useLoader.preload(
  // @ts-expect-error
  TextureLoader,
  placeUrl
);
export default function App() {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);

  const [model, setModel] = useState(null);

  const result = useLoader(GLTFLoader, modelUrl, (loader) => {
    loader.manager.onLoad = (e) => {
      globalActor.send({ type: "LOADED_GLTF" });
    };
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(process.env.PUBLIC_URL + "/draco/");
    loader.setDRACOLoader(dracoLoader);
  });
  const env = useEnvironment({ files: envUrl });
  const placeTex = useLoader(TextureLoader, placeUrl);

  // console.log("RESULT", result, env);

  if (window.location.href.match("fake")) {
    return (
      <>
        {state !== "loading" && state !== "start" && state !== "disclaimer" ? (
          <Canvas style={{ zIndex: -1 }}>
            <color attach="background" args={[0xcccccc]} />
            <gridHelper args={[20, 20, 0xff0000, "teal"]} />
            <Suspense fallback={<Loader />}>
              <Scene model={result} env={env} placeTex={placeTex} />
            </Suspense>
            <OrbitControls />
          </Canvas>
        ) : (
          ""
        )}
        <Dom></Dom>
      </>
    );
  }
  return (
    <>
      {state !== "loading" && state !== "start" && state !== "disclaimer" ? (
        <ZapparCanvas>
          <Suspense fallback={<Loader />}>
            <ZapparCamera
              onFirstFrame={() => {
                globalActor.send({ type: "STARTED" });
              }}
            />
            <Scene model={result} env={env} placeTex={placeTex} />
          </Suspense>
        </ZapparCanvas>
      ) : (
        ""
      )}

      <Dom></Dom>
      <BrowserCompatibility
      // fallback={<div>Sorry!</div>}
      />
    </>
  );
}

// npx gltfjsx miebo-v1.glb  --transform
